import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { Stack } from 'src/components/Stack';

interface EditButtonProps {
  editTitle?: React.ReactNode;
  saveTitle?: React.ReactNode;
  onClickEdit?: () => void;
  onClickSave?: () => void;
  onClickCancel?: () => void;
  editing?: boolean;
  saving?: boolean;
  disabled?: boolean;
  sx?;
}

export const EditButton: React.FC<EditButtonProps> = ({
  editTitle = 'Edit',
  saveTitle = 'Save',
  onClickEdit,
  onClickCancel,
  onClickSave,
  editing = false,
  saving = false,
  disabled,
  sx,
}) => {
  return (
    <>
      {editing && (
        <Stack direction="row" spacing={2} sx={sx}>
          {onClickCancel && (
            <IconButton
              onClick={onClickCancel}
              color="info"
              disabled={disabled}
            >
              <Icon icon={icon({ name: 'ban', style: 'regular' })} />
            </IconButton>
          )}
          <Button
            color="primary"
            variant="contained"
            startIcon={<Icon icon={icon({ name: 'save', style: 'regular' })} />}
            onClick={onClickSave}
            loading={saving}
            disabled={disabled}
          >
            {saveTitle}
          </Button>
        </Stack>
      )}
      {!editing && (
        <Button
          startIcon={<Icon icon={icon({ name: 'edit', style: 'regular' })} />}
          variant="outlined"
          color="primary"
          onClick={onClickEdit}
          loading={saving}
          disabled={disabled}
          sx={sx}
        >
          {editTitle}
        </Button>
      )}
    </>
  );
};
